import React from "react";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import PublicRoutes from "./PublicRoutes";
import PrivateRoutes from "./PrivateRoutes";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import EmailEntryScreen from "../pages/sharing/EmailEntryScreen";
import OtpEntryScreen from "../pages/sharing/OtpEntryScreen";
import PaymentProcessingScreen from "../pages/payment/PaymentProcessing";
import NotFound from "../pages/NotFoundPage";
import NotFoundPage from "../pages/OrderNotFound";
import Privacy from "../pages/Privacy/Privacy";
import DeleteAccount from "../pages/deleteAccount/deleteAccount";

function Navigation() {
  return (
    <HashRouter>
      {/* <BrowserRouter> */}
      <Routes>
        <Route path="/privacypolicy" element={<Privacy />} />
        <Route path="/support/delete-account" element={<DeleteAccount />} />
        <Route path="/view-doc/:param" element={<EmailEntryScreen />} />
        <Route path="/otp-entry" element={<OtpEntryScreen />} />
        <Route
          path="/"
          element={
            <PublicRoutes restricted={false}>
              <Home />
            </PublicRoutes>
          }
        />
        <Route
          path="/login"
          element={
            <PublicRoutes restricted={true}>
              <Login />
            </PublicRoutes>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoutes>
              <Dashboard />
            </PrivateRoutes>
          }
        />
        <Route
          path="/payment-processing/:orderId"
          element={<PaymentProcessingScreen />}
        />
        <Route path="/order-not-found" element={<NotFoundPage />} />
        <Route path="/not-found" element={<NotFound />} />
      </Routes>
      {/*</BrowserRouter> */}
    </HashRouter>
  );
}

export default Navigation;
